import { useUiFromSpecContext } from '../EditorContextProvider'
import { RenderUiFromSpec } from './RenderUiFromSpec'
import { UiFromSpecProps } from '../UiFromSpec'
import clsx from 'clsx'
import { fontFamilyClasses } from './constant/fontFamilyClasses'

export const RenderUi = (props: UiFromSpecProps) => {
  const xpath = ''
  const { form, onSubmit } = props
  const { currentSpec, designState } = useUiFromSpecContext()

  // Get the font family class, fallback to font-sans
  const fontFamilyClass = fontFamilyClasses[designState.fontFamily as keyof typeof fontFamilyClasses] || 'font-sans'

  return (
    <div className={clsx('flex py-4 flex-col space-y-2', fontFamilyClass)}>
      <form
        onSubmit={(event) => {
          event.preventDefault()
          form.handleSubmit(
            onSubmit
              ? onSubmit
              : (data) => {
                  console.log(data)
                }
          )()
        }}
      >
        <div className="flex">
          {currentSpec &&
            currentSpec.map((item: any, index: number) => {
              return (
                <RenderUiFromSpec
                  {...props}
                  key={index}
                  xpath={xpath + index}
                  item={item}
                  index={index}
                  className={item.className}
                  children={item.children}
                  title={''}
                />
              )
            })}
        </div>
      </form>
    </div>
  )
}
